import { useEffect } from 'react';
import '../styles/TechologiesPage.scss';
import { Row, Col } from 'react-simple-flex-grid';
import metaHumanSectionBg from '../images/metahuman_section_bg.jpg';
import { TechnologiesMore } from './TechnologiesMore';
import { useInView } from 'react-intersection-observer';
import GenAI from './GenAI';
import { TechnologiesContacts } from './TechnologiesContacts';

function Technologies(props: { title: string }) {
  useEffect(() => {
    document.title = props.title;
  });

  const [genAiSectionRef, genAiSectionRefInView] = useInView({
    triggerOnce: true,
    threshold: 0.4,
  });

  const [technologiesSectionRef, technologiesSectionRefInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const [metaHumanSectionRef, metaHumanSectionRefInView] = useInView({
    triggerOnce: true,
    threshold: 0.4,
  });

  const [technologiesMoreSectionRef, technologiesMoreSectionRefInView] =
    useInView({
      triggerOnce: true,
      threshold: 0.4,
    });

  const [technologiesContactsSectionRef, technologiesContactsSectionRefInView] =
    useInView({
      triggerOnce: true,
      threshold: 0.4,
    });

  return (
    <div className="technologies-page-wrapper">
      <div
        ref={technologiesSectionRef}
        className={
          technologiesSectionRefInView
            ? 'technologies-section slideInUp'
            : 'technologies-section'
        }
      >
        <Row align="center">
          <Col xs={11}>
            <h1>
              Tech Deep Dive
              <span className="semi-transparent">from the future</span>
            </h1>
          </Col>
        </Row>
        <div className="section-shadow section-shadow-from-bottom"></div>
      </div>
      <div
        ref={metaHumanSectionRef}
        className={
          metaHumanSectionRefInView
            ? 'meta-human-section slideInUp'
            : 'meta-human-section'
        }
      >
        <div className="section-shadow section-shadow-from-top"></div>
        <Row className="meta-human-raw">
          <Col xs={10}>
            <h3 className="section-title">Meta human</h3>
            <h5 className="section-subtitle">
              MetaHuman Creator + <br className="mobile" /> Blender + Unreal
              Engine
            </h5>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <img src={metaHumanSectionBg} alt="section background" />
          </Col>
        </Row>
        <Row gutter={60}>
          <Col xs={12} sm={6}>
            <p className="footer-description wrapper">
              Alnair comes to life with MetaHuman Creator (Epic Games). Other
              tools like Blender are used for body and clothing animation and
              textures, plus digital clothing design and "sewing." Unreal Engine
              creates Alnair’s background environment.
            </p>
          </Col>
        </Row>
        <div className="section-shadow section-shadow-from-bottom"></div>
      </div>
      <div
        ref={genAiSectionRef}
        className={`${
          genAiSectionRefInView ? 'genai-section slideInUp' : 'genai-section'
        }`}
      >
        <div className="section-shadow section-shadow-from-top"></div>
        <GenAI />
        <div className="section-shadow section-shadow-from-bottom"></div>
      </div>
      <div
        ref={technologiesMoreSectionRef}
        className={
          technologiesMoreSectionRefInView
            ? 'technologies-more-section slideInUp'
            : 'technologies-more-section'
        }
      >
        <div className="section-shadow section-shadow-from-top"></div>
        <TechnologiesMore />
        <div className="section-shadow section-shadow-from-bottom"></div>
      </div>

      <div
        ref={technologiesContactsSectionRef}
        className={
          technologiesContactsSectionRefInView
            ? 'technologies-contacts-section slideInUp'
            : 'technologies-contacts-section'
        }
      >
        <div className="section-shadow section-shadow-from-top"></div>
        <TechnologiesContacts />
        <div className="section-shadow section-shadow-from-bottom"></div>
      </div>
    </div>
  );
}

export default Technologies;
